<template>
    <v-app-bar
        color="headerBackground"
        id="alv-toolbar"
        clipped-left        
        height="80px"
        fixed                
        flat
        app        
    >

        <v-img
            :src="require('../assets/logo/alv_logo_vector.svg')"
            alt="ALV Logo"
            height="70%"
            max-width="100px"
            contain
            @click="goToDashboard"
            :alvqa="alvqa + '-alv-logo'"
        />     

        <v-spacer></v-spacer>

        <BaseTooltip v-if="isNda">
            <template v-slot:content>
                <v-img
                    :src="getNdaBadge"
                    alt="NDA-Partner"
                    height="80%"
                    max-width="60px"
                    contain
                    :alvqa="alvqa + '-alv-nda-badge'"
                />   
            </template>
            <template v-slot:text>
                {{ getNdaTooltipText }}
            </template>
        </BaseTooltip>

        <BaseTooltip>
            <template v-slot:content>
                <v-img
                    :src="getByUserRole"
                    :alt="userRoleTooltipText"
                    height="80%"
                    max-width="60px"
                    contain
                    :alvqa="alvqa + '-alv-user-badge-' + $store.getters['getUserInformation'].role"
                />   
            </template>
            <template v-slot:text>
                {{ userRoleTooltipText }}
            </template>
        </BaseTooltip>

        <v-toolbar-items>
            <v-btn 
                class="black--text" 
                text
                :alvqa="alvqa + '-button-username'"

            >
                <div style="line-height: 80%">{{ username }}<br /><span class="ellipsis subtitleGray--text"><br />{{ company }}</span></div>
            </v-btn>              
            <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                    <v-btn
                        class="black--text" 
                        text
                        v-on="on"
                        :alvqa="alvqa + '-dropdown-language-' + language"
                    >
                        {{ $t(selectedLang) }}
                    </v-btn>
                    </template>
                    <v-list>
                    <v-list-item
                        v-for="(item, index) in languages"
                        :key="index"
                        @click="changeLanguage(item)"
                        :alvqa="alvqa + '-dropdown-language-' + item.value"
                    >
                        <v-list-item-title :class = "{  'generalDropdownSelected--text' : item.value === language}">{{ item.native }}</v-list-item-title>
                    </v-list-item>
                    </v-list>
                </v-menu>            
            <v-btn 
                class="black--text"
                text
                @click="logout"
                :alvqa="alvqa + '-button-logout'"
                >{{ logoutButton }}</v-btn>
        </v-toolbar-items>

        <template slot="extension">
            <v-sheet 
                tile
                :width="$store.getters.getDrawer ? 56 : 280" 
                class="text-left pl-1 headerExtensionAboveNavigation" 
                color="headerExtensionAboveNavigation"
            >
                <v-btn icon class="ma-0" @click="toggleMenu()">                    
                    <svg v-if="!$store.getters.getOpenDriver" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M13 20V4h2.03v16zm-3 0V4h2.03v16zM5 8l4.03 4L5 16v-3H2v-2h3zm15 8l-4-4l4-4v3h3v2h-3z"/></svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M9 11h6V8l4 4l-4 4v-3H9v3l-4-4l4-4zm-7 9V4h2v16zm18 0V4h2v16z"/></svg>
                </v-btn>
            </v-sheet>  
            <span class="ml-3" > 
                <BaseIcon                            
                    color="breadcrumbIcon" 
                    icon="home" 
                />
            </span> 
            <BaseBreadcrumbs />                
        </template>
    </v-app-bar>
</template>

<script>
import { mapActions } from 'vuex'
import BaseBreadcrumbs from './_base/BaseBreadcrumbs'
import BaseIcon from './_buttons/BaseIcon'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "Header",
    components: {
        BaseBreadcrumbs,
        BaseIcon,
        BaseTooltip,
    },
    data() {
        return {
            username: this.$store.getters.getUserUsername,
            company: this.$store.getters.getUserCustomerCompany,
            language: this.$i18n.locale,
            alvqa: "header",
            userRoleTooltipText: '',
        }   
    },
    computed: {
		/** Returns the logout button label in the chosen language. 
         * @return {String} button label */        
        logoutButton() { return this.$t('lang_HEADER_BUTTON_LOGOUT') },

        languages() { 
            let languages = JSON.parse(JSON.stringify(this.$store.getters.getGeneralLanguages))
            return languages
            // let languagesWithoutJapanese = languages.filter(languge => {
            //     return languge.value !== 'ja'
            // })
            // return languagesWithoutJapanese
        },
        selectedLang() {
            if(this.languages === null) return ''
            else {
                return this.languages.find(language => {
                    return language.value === this.$i18n.locale
                }).text
            }
        },
        getByUserRole() {
            let userLoginRole = this.$store.getters["getUserInformation"].role
            let imagePath = ''
            switch(userLoginRole) {
                case 'admin':
                    imagePath = '/badges/users/administrator.svg'
                    this.userRoleTooltipText = this.$t('lang_ACCOUNT_CREDENTIALS_ROLE_OPTION_ADMIN')
                    break
                case 'coworker': // change to "contributor"
                    imagePath = '/badges/users/contributor.svg'
                    this.userRoleTooltipText = this.$t('lang_ACCOUNT_CREDENTIALS_ROLE_OPTION_COWORKER')
                    break
                case 'assistant':
                    imagePath = '/badges/users/assistant.svg'
                    this.userRoleTooltipText = this.$t('lang_ACCOUNT_CREDENTIALS_ROLE_OPTION_ASSISTANT')
                    break
                default:
                    imagePath = ''
                    this.userRoleTooltipText = 'Role not set... weird!'
                    break
            }
            return require('../assets/media' + imagePath)
        },
        getNdaTooltipText() {
            return this.$t('lang_GENERIC_CAPTION_NDA_PARTNER')
        },
        getNdaBadge() {
            return require('../assets/media/badges/users/nda-partner.svg')
        },
        isNda() {
            return (this.$store.getters["getUserInformation"].nda ? true : false)
        }
    },
    methods: {
        toggleMenu() { 
            this.$store.commit('setDrawer', !this.$store.getters.getDrawer)
            this.$store.commit('setOpenDriver', !this.$store.getters.getOpenDriver)
        },
        ...mapActions(['fetchI18nMessages']),

        /** Change the language by clicking the button.
         * The function checks the given param to change the language with switch-case, 
         * and fetch the chosen language from the DB.
         *  
         * @listens event:click 
         * @param {String} language String of the selected language. */
        async changeLanguage(item) { 
            if(item.value !== this.language) {
                this.language = item.value
                localStorage.setItem('uiLanguage', item.value)
                this.fetchI18nMessages(item.value) 
            }
        },

        /** Change the route to '/dashboard', when the alv logo is clicked.
         *  @listens event:click */
        goToDashboard() { this.$router.push('/dashboard') },

        /** Logs out the user.
         * Logs out the user by removing the token from the localStorage, 
         * redirect the user to the Login page and set the IsLoggedIn Object in the vuex store to 'false'.
         * 
         * @listens event:click */
        logout() {
            localStorage.clear()  
            this.$router.go()
            // this.$store.commit('setInitialStoreModules')
            this.$router.push('/login')            
        }        
    }
};
</script>

<style>
#alv-toolbar .v-toolbar__extension {
    padding: 0;
    background-color:var(--v-headerExtensionAboveContent-base);
}
.headerExtensionAboveNavigation {
    transition: width 0.3s;
}
</style>
